export default __webpack_public_path__ + "static/Aexey Hramchenko-924878bb9ce1d7364027135d03859e7e.png";